var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio',{class:[
    _vm.selectedValue === _vm.value ? 'radio-selected' : '',
    'radio-border',
    _vm.down ? 'radio-down' : _vm.up ? 'radio-up' : '',
  ],attrs:{"color":"red","value":_vm.value},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{class:[_vm.selectedValue === _vm.value ? 'red--text' : '']},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_c('div',[_vm._v("\n        "+_vm._s(_vm.description)+"\n      ")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }